import { Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { InputBaseReactComponent } from '../input-base-react/input-base-react.component';
import { DataModel } from 'app/shared/models/DataModel';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-input-boolean-dropdown-react',
    templateUrl: './input-boolean-dropdown-react.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputBooleanDropDownReactComponent),
            multi: true
        }
    ]
})

export class InputBooleanDropDownReactComponent extends InputBaseReactComponent implements ControlValueAccessor, OnInit, OnChanges {

    // atributo utilizado para efetuar preenchimento de itens
    public items: Array<DataModel> = [];
    @Input() tipoStatus: boolean;
    @Input() incluirOpcaoTodos = true;

    constructor() {

        super();
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.tipoStatus) {
            this.items = [
                { id: true, nome: 'Ativo', complementar: null },
                { id: false, nome: 'Inativo', complementar: null }
            ]

            if (this.incluirOpcaoTodos) {
                this.items.unshift({ id: null, nome: 'Todos', complementar: null });
            }

        } else {
            this.items = [
                { id: true, nome: 'Sim', complementar: null },
                { id: false, nome: 'Não', complementar: null }
            ]
        }

        if (this.value) {
            this.control.setValue(this.value);
            this.valorChange.emit(this.value);
        }
        this.setAndUpdateValidators();
    }

    ngOnChanges(): void {
        super.ngOnChanges();
        this.setAndUpdateValidators();
    }

    public getComboItemText(): string {
        if (this.control) {
            if ((this.items) && (this.items.length > 0)) {
                const item: DataModel = this.items.find(m => m.id === this.value);

                return (item ? item.nome : '');
            }
        } else {
            return '';
        }
    }

}
